import { ErrorHandler, Injectable } from '@angular/core';
import * as Rollbar from 'rollbar';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RollbarService implements ErrorHandler {
  private rollbar?: Rollbar;

  constructor() {
    if(
      environment.ROLLBAR_CONFIG.ROLLBAR_ENVIRONMENT === 'development'
    ) {
      this.rollbar = new Rollbar({
        accessToken: environment.ROLLBAR_CONFIG.ROLLBAR_ACCESS_TOKEN,
        captureUncaught: true,
        captureUnhandledRejections: true,
        environment: environment.ROLLBAR_CONFIG.ROLLBAR_ENVIRONMENT,
      });
    }
  }

  handleError(error: any): void {
    this.log(error);
    console.error(error);
  }

  log(error: any, data?: Record<string, unknown>): void {
    if (!this.rollbar) return;

    const normalizedError = error?.ngOriginalError || error?.originalError || error;

    if (normalizedError instanceof Error) {
      this.rollbar.error(normalizedError, data);
      return;
    }

    if (typeof normalizedError === 'string' && normalizedError.trim()) {
      this.rollbar.error(normalizedError, data);
      return;
    }

    const message = normalizedError?.message || 'Unhandled application error';
    this.rollbar.error(String(message), data);
  }

  info(message: any): void {
    if (message) this.rollbar?.info(String(message));
  }

  warn(message: any): void {
    if (message) this.rollbar?.warning(String(message));
  }
}
